import {CountryCode} from "@/api/paymentApi";

const US_PROFILE = ["dev", "prod"]
const EU_PROFILE = ["dev-eu", "prod-eu"]

export const CountryCodeList = [
        {
            "displayText": "Aruba",
            "value": CountryCode.ABW,
            "dialCode": "+297",
            "twoLetterCode": "AW"
        },
        {
            "displayText": "Afghanistan",
            "value": CountryCode.AFG,
            "dialCode": "+93",
            "twoLetterCode": "AF"
        },
        {
            "displayText": "Angola",
            "value": CountryCode.AGO,
            "dialCode": "+244",
            "twoLetterCode": "AO"
        },
        {
            "displayText": "Anguilla",
            "value": CountryCode.AIA,
            "dialCode": "+1264",
            "twoLetterCode": "AI"
        },
        {
            "displayText": "Aland Islands",
            "value": CountryCode.ALA,
            "dialCode": "+358",
            "twoLetterCode": "AX"
        },
        {
            "displayText": "Albania",
            "value": CountryCode.ALB,
            "dialCode": "+355",
            "twoLetterCode": "AL"
        },
        {
            "displayText": "Andorra",
            "value": CountryCode.AND,
            "dialCode": "+376",
            "twoLetterCode": "AD"
        },
        {
            "displayText": "Netherlands Antilles",
            "value": CountryCode.ANT,
            "dialCode": "+599",
            "twoLetterCode": "AN"
        },
        {
            "displayText": "United Arab Emirates",
            "value": CountryCode.ARE,
            "dialCode": "+971",
            "twoLetterCode": "AE"
        },
        {
            "displayText": "Argentina",
            "value": CountryCode.ARG,
            "dialCode": "+54",
            "twoLetterCode": "AR"
        },
        {
            "displayText": "Armenia",
            "value": CountryCode.ARM,
            "dialCode": "+374",
            "twoLetterCode": "AM"
        },
        {
            "displayText": "American Samoa",
            "value": CountryCode.ASM,
            "dialCode": "+1684",
            "twoLetterCode": "AS"
        },
        {
            "displayText": "Antarctica",
            "value": CountryCode.ATA,
            "dialCode": "+672",
            "twoLetterCode": "AQ"
        },
        {
            "displayText": "French Southern Territories",
            "value": CountryCode.ATF,
            "dialCode": "+262",
            "twoLetterCode": "TF"
        },
        {
            "displayText": "Antigua And Barbuda",
            "value": CountryCode.ATG,
            "dialCode": "+1268",
            "twoLetterCode": "AG"
        },
        {
            "displayText": "Australia",
            "value": CountryCode.AUS,
            "dialCode": "+61",
            "twoLetterCode": "AU"
        },
        {
            "displayText": "Austria",
            "value": CountryCode.AUT,
            "dialCode": "+43",
            "enableCbPayments": true,
            "restrictedEnv": US_PROFILE,
            "twoLetterCode": "AT"
        },
        {
            "displayText": "Azerbaijan",
            "value": CountryCode.AZE,
            "dialCode": "+994",
            "twoLetterCode": "AZ"
        },
        {
            "displayText": "Burundi",
            "value": CountryCode.BDI,
            "dialCode": "+257",
            "twoLetterCode": "BI"
        },
        {
            "displayText": "Belgium",
            "value": CountryCode.BEL,
            "dialCode": "+32",
            "enableCbPayments": true,
            "restrictedEnv": US_PROFILE,
            "twoLetterCode": "BE"
        },
        {
            "displayText": "Benin",
            "value": CountryCode.BEN,
            "dialCode": "+229",
            "twoLetterCode": "BJ"
        },
        {
            "displayText": "Sint Eustatius And Saba Bonaire",
            "value": CountryCode.BES,
            "dialCode": "+599",
            "twoLetterCode": "BQ"
        },
        {
            "displayText": "Burkina Faso",
            "value": CountryCode.BFA,
            "dialCode": "+226",
            "twoLetterCode": "BF"
        },
        {
            "displayText": "Bangladesh",
            "value": CountryCode.BGD,
            "dialCode": "+880",
            "twoLetterCode": "BD"
        },
        {
            "displayText": "Bulgaria",
            "value": CountryCode.BGR,
            "dialCode": "+359",
            "twoLetterCode": "BG"
        },
        {
            "displayText": "Bahrain",
            "value": CountryCode.BHR,
            "dialCode": "+973",
            "twoLetterCode": "BH"
        },
        {
            "displayText": "Bahamas",
            "value": CountryCode.BHS,
            "dialCode": "+1242",
            "twoLetterCode": "BS"
        },
        {
            "displayText": "Bosnia And Herzegovina",
            "value": CountryCode.BIH,
            "dialCode": "+387",
            "twoLetterCode": "BA"
        },
        {
            "displayText": "Saint Barthélemy",
            "value": CountryCode.BLM,
            "dialCode": "+590",
            "twoLetterCode": "BL"
        },
        {
            "displayText": "Belarus",
            "value": CountryCode.BLR,
            "dialCode": "+375",
            "twoLetterCode": "BY"
        },
        {
            "displayText": "Belize",
            "value": CountryCode.BLZ,
            "dialCode": "+501",
            "twoLetterCode": "BZ"
        },
        {
            "displayText": "Bermuda",
            "value": CountryCode.BMU,
            "dialCode": "+1441",
            "twoLetterCode": "BM"
        },
        {
            "displayText": "Bolivia",
            "value": CountryCode.BOL,
            "dialCode": "+591",
            "twoLetterCode": "BO"
        },
        {
            "displayText": "Brazil",
            "value": CountryCode.BRA,
            "dialCode": "+55",
            "twoLetterCode": "BR"
        },
        {
            "displayText": "Barbados",
            "value": CountryCode.BRB,
            "dialCode": "+1246",
            "twoLetterCode": "BB"
        },
        {
            "displayText": "Brunei Darussalam",
            "value": CountryCode.BRN,
            "dialCode": "+673",
            "twoLetterCode": "BN"
        },
        {
            "displayText": "Bhutan",
            "value": CountryCode.BTN,
            "dialCode": "+975",
            "twoLetterCode": "BT"
        },
        {
            "displayText": "Bouvet Island",
            "value": CountryCode.BVT,
            "dialCode": "+47",
            "twoLetterCode": "BV"
        },
        {
            "displayText": "Botswana",
            "value": CountryCode.BWA,
            "dialCode": "+267",
            "twoLetterCode": "BW"
        },
        {
            "displayText": "Central African Republic",
            "value": CountryCode.CAF,
            "dialCode": "+236",
            "twoLetterCode": "CF"
        },
        {
            "displayText": "Canada",
            "value": CountryCode.CAN,
            "dialCode": "+1",
            "twoLetterCode": "CA"
        },
        {
            "displayText": "Cocos (Keeling) Islands",
            "value": CountryCode.CCK,
            "dialCode": "+61",
            "twoLetterCode": "CC"
        },
        {
            "displayText": "Switzerland",
            "value": CountryCode.CHE,
            "dialCode": "+41",
            "twoLetterCode": "CH"
        },
        {
            "displayText": "Chile",
            "value": CountryCode.CHL,
            "dialCode": "+56",
            "twoLetterCode": "CL"
        },
        {
            "displayText": "China",
            "value": CountryCode.CHN,
            "dialCode": "+86",
            "twoLetterCode": "CN"
        },
        {
            "displayText": "Côte D'ivoire",
            "value": CountryCode.CIV,
            "dialCode": "+225",
            "twoLetterCode": "CI"
        },
        {
            "displayText": "Cameroon",
            "value": CountryCode.CMR,
            "dialCode": "+237",
            "twoLetterCode": "CM"
        },
        {
            "displayText": "Congo (Democratic Republic)",
            "value": CountryCode.COD,
            "dialCode": "+243",
            "twoLetterCode": "CD"
        },
        {
            "displayText": "Congo",
            "value": CountryCode.COG,
            "dialCode": "+242",
            "twoLetterCode": "CG"
        },
        {
            "displayText": "Cook Islands",
            "value": CountryCode.COK,
            "dialCode": "+682",
            "twoLetterCode": "CK"
        },
        {
            "displayText": "Colombia",
            "value": CountryCode.COL,
            "dialCode": "+57",
            "twoLetterCode": "CO"
        },
        {
            "displayText": "Comoros",
            "value": CountryCode.COM,
            "dialCode": "+269",
            "twoLetterCode": "KM"
        },
        {
            "displayText": "Cape Verde",
            "value": CountryCode.CPV,
            "dialCode": "+238",
            "twoLetterCode": "CV"
        },
        {
            "displayText": "Costa Rica",
            "value": CountryCode.CRI,
            "dialCode": "+506",
            "twoLetterCode": "CR"
        },
        {
            "displayText": "Cuba",
            "value": CountryCode.CUB,
            "dialCode": "+53",
            "twoLetterCode": "CU"
        },
        {
            "displayText": "Curaçao",
            "value": CountryCode.CUW,
            "dialCode": "+599",
            "twoLetterCode": "CW"
        },
        {
            "displayText": "Christmas Island",
            "value": CountryCode.CXR,
            "dialCode": "+61",
            "twoLetterCode": "CX"
        },
        {
            "displayText": "Cayman Islands",
            "value": CountryCode.CYM,
            "dialCode": "+1345",
            "twoLetterCode": "KY"
        },
        {
            "displayText": "Cyprus",
            "value": CountryCode.CYP,
            "dialCode": "+357",
            "twoLetterCode": "CY"
        },
        {
            "displayText": "Czech Republic",
            "value": CountryCode.CZE,
            "dialCode": "+420",
            "twoLetterCode": "CZ"
        },
        {
            "displayText": "Germany",
            "value": CountryCode.DEU,
            "dialCode": "+49",
            "enableCbPayments": true,
            "restrictedEnv": US_PROFILE,
            "twoLetterCode": "DE"
        },
        {
            "displayText": "Djibouti",
            "value": CountryCode.DJI,
            "dialCode": "+253",
            "twoLetterCode": "DJ"
        },
        {
            "displayText": "Dominica",
            "value": CountryCode.DMA,
            "dialCode": "+1767",
            "twoLetterCode": "DM"
        },
        {
            "displayText": "Denmark",
            "value": CountryCode.DNK,
            "dialCode": "+45",
            "twoLetterCode": "DK"
        },
        {
            "displayText": "Dominican Republic",
            "value": CountryCode.DOM,
            "dialCode": "+1",
            "twoLetterCode": "DO"
        },
        {
            "displayText": "Algeria",
            "value": CountryCode.DZA,
            "dialCode": "+213",
            "twoLetterCode": "DZ"
        },
        {
            "displayText": "Spain - Ceuta and Melilla",
            "value": CountryCode.EAC,
            "dialCode": "+34",
            "twoLetterCode": "EA"
        },
        {
            "displayText": "Ecuador",
            "value": CountryCode.ECU,
            "dialCode": "+593",
            "twoLetterCode": "EC"
        },
        {
            "displayText": "Egypt",
            "value": CountryCode.EGY,
            "dialCode": "+20",
            "twoLetterCode": "EG"
        },
        {
            "displayText": "Eritrea",
            "value": CountryCode.ERI,
            "dialCode": "+291",
            "twoLetterCode": "ER"
        },
        {
            "displayText": "Western Sahara",
            "value": CountryCode.ESH,
            "dialCode": "+212",
            "twoLetterCode": "EH"
        },
        {
            "displayText": "Spain",
            "value": CountryCode.ESP,
            "dialCode": "+34",
            "enableCbPayments": true,
            "restrictedEnv": US_PROFILE,
            "twoLetterCode": "ES"
        },
        {
            "displayText": "Estonia",
            "value": CountryCode.EST,
            "dialCode": "+372",
            "twoLetterCode": "EE"
        },
        {
            "displayText": "Ethiopia",
            "value": CountryCode.ETH,
            "dialCode": "+251",
            "twoLetterCode": "ET"
        },
        {
            "displayText": "Finland",
            "value": CountryCode.FIN,
            "dialCode": "+358",
            "enableCbPayments": true,
            "restrictedEnv": US_PROFILE,
            "twoLetterCode": "FI"
        },
        {
            "displayText": "Fiji",
            "value": CountryCode.FJI,
            "dialCode": "+679",
            "twoLetterCode": "FJ"
        },
        {
            "displayText": "Falkland Islands (Malvinas)",
            "value": CountryCode.FLK,
            "dialCode": "+500",
            "twoLetterCode": "FK"
        },
        {
            "displayText": "France",
            "value": CountryCode.FRA,
            "dialCode": "+33",
            "enableCbPayments": true,
            "restrictedEnv": US_PROFILE,
            "twoLetterCode": "FR"
        },
        {
            "displayText": "Faroe Islands",
            "value": CountryCode.FRO,
            "dialCode": "+298",
            "twoLetterCode": "FO"
        },
        {
            "displayText": "Micronesia",
            "value": CountryCode.FSM,
            "dialCode": "+691",
            "twoLetterCode": "FM"
        },
        {
            "displayText": "Gabon",
            "value": CountryCode.GAB,
            "dialCode": "+241",
            "twoLetterCode": "GA"
        },
        {
            "displayText": "United Kingdom",
            "value": CountryCode.GBR,
            "dialCode": "+44",
            "enableCbPayments": true,
            "restrictedEnv": US_PROFILE,
            "twoLetterCode": "GB"
        },
        {
            "displayText": "Georgia",
            "value": CountryCode.GEO,
            "dialCode": "+995",
            "twoLetterCode": "GE"
        },
        {
            "displayText": "Guernsey",
            "value": CountryCode.GGY,
            "dialCode": "+44",
            "twoLetterCode": "GG"
        },
        {
            "displayText": "Ghana",
            "value": CountryCode.GHA,
            "dialCode": "+233",
            "twoLetterCode": "GH"
        },
        {
            "displayText": "Gibraltar",
            "value": CountryCode.GIB,
            "dialCode": "+350",
            "twoLetterCode": "GI"
        },
        {
            "displayText": "Guinea",
            "value": CountryCode.GIN,
            "dialCode": "+224",
            "twoLetterCode": "GN"
        },
        {
            "displayText": "Guadeloupe",
            "value": CountryCode.GLP,
            "dialCode": "+590",
            "twoLetterCode": "GP"
        },
        {
            "displayText": "Gambia",
            "value": CountryCode.GMB,
            "dialCode": "+220",
            "twoLetterCode": "GM"
        },
        {
            "displayText": "Guinea-bissau",
            "value": CountryCode.GNB,
            "dialCode": "+245",
            "twoLetterCode": "GW"
        },
        {
            "displayText": "Equatorial Guinea",
            "value": CountryCode.GNQ,
            "dialCode": "+240",
            "twoLetterCode": "GQ"
        },
        {
            "displayText": "Greece",
            "value": CountryCode.GRC,
            "dialCode": "+30",
            "twoLetterCode": "GR"
        },
        {
            "displayText": "Grenada",
            "value": CountryCode.GRD,
            "dialCode": "+1473",
            "twoLetterCode": "GD"
        },
        {
            "displayText": "Greenland",
            "value": CountryCode.GRL,
            "dialCode": "+299",
            "twoLetterCode": "GL"
        },
        {
            "displayText": "Guatemala",
            "value": CountryCode.GTM,
            "dialCode": "+502",
            "twoLetterCode": "GT"
        },
        {
            "displayText": "French Guiana",
            "value": CountryCode.GUF,
            "dialCode": "+594",
            "twoLetterCode": "GF"
        },
        {
            "displayText": "Guam",
            "value": CountryCode.GUM,
            "dialCode": "+1671",
            "twoLetterCode": "GU"
        },
        {
            "displayText": "Guyana",
            "value": CountryCode.GUY,
            "dialCode": "+592",
            "twoLetterCode": "GY"
        },
        {
            "displayText": "Hong Kong",
            "value": CountryCode.HKG,
            "dialCode": "+852",
            "twoLetterCode": "HK"
        },
        {
            "displayText": "Heard Island And Mcdonald Islands",
            "value": CountryCode.HMD,
            "dialCode": "+672",
            "twoLetterCode": "HM"
        },
        {
            "displayText": "Honduras",
            "value": CountryCode.HND,
            "dialCode": "+504",
            "twoLetterCode": "HN"
        },
        {
            "displayText": "Croatia",
            "value": CountryCode.HRV,
            "dialCode": "+385",
            "twoLetterCode": "HR"
        },
        {
            "displayText": "Haiti",
            "value": CountryCode.HTI,
            "dialCode": "+509",
            "twoLetterCode": "HT"
        },
        {
            "displayText": "Hungary",
            "value": CountryCode.HUN,
            "dialCode": "+36",
            "twoLetterCode": "HU"
        },
        {
            "displayText": "Spain - Canary Islands",
            "value": CountryCode.IC,
            "dialCode": "+34",
            "twoLetterCode": "IC"
        },
        {
            "displayText": "Indonesia",
            "value": CountryCode.IDN,
            "dialCode": "+62",
            "twoLetterCode": "ID"
        },
        {
            "displayText": "Isle Of Man",
            "value": CountryCode.IMN,
            "dialCode": "+44",
            "twoLetterCode": "IM"
        },
        {
            "displayText": "India",
            "value": CountryCode.IND,
            "dialCode": "+91",
            "twoLetterCode": "IN"
        },
        {
            "displayText": "British Indian Ocean Territory",
            "value": CountryCode.IOT,
            "dialCode": "+246",
            "twoLetterCode": "IO"
        },
        {
            "displayText": "Ireland",
            "value": CountryCode.IRL,
            "dialCode": "+353",
            "twoLetterCode": "IE",
            "enableCbPayments": true,
            "restrictedEnv": US_PROFILE,
        },
        {
            "displayText": "Iran",
            "value": CountryCode.IRN,
            "dialCode": "+98",
            "twoLetterCode": "IR"
        },
        {
            "displayText": "Iraq",
            "value": CountryCode.IRQ,
            "dialCode": "+964",
            "twoLetterCode": "IQ"
        },
        {
            "displayText": "Iceland",
            "value": CountryCode.ISL,
            "dialCode": "+354",
            "twoLetterCode": "IS"
        },
        {
            "displayText": "Israel",
            "value": CountryCode.ISR,
            "dialCode": "+972",
            "twoLetterCode": "IL"
        },
        {
            "displayText": "Italy",
            "value": CountryCode.ITA,
            "dialCode": "+39",
            "enableCbPayments": true,
            "restrictedEnv": US_PROFILE,
            "twoLetterCode": "IT"
        },
        {
            "displayText": "Jamaica",
            "value": CountryCode.JAM,
            "dialCode": "+1876",
            "twoLetterCode": "JM"
        },
        {
            "displayText": "Jersey",
            "value": CountryCode.JEY,
            "dialCode": "+44",
            "twoLetterCode": "JE"
        },
        {
            "displayText": "Jordan",
            "value": CountryCode.JOR,
            "dialCode": "+962",
            "twoLetterCode": "JO"
        },
        {
            "displayText": "Japan",
            "value": CountryCode.JPN,
            "dialCode": "+81",
            "twoLetterCode": "JP"
        },
        {
            "displayText": "Kazakhstan",
            "value": CountryCode.KAZ,
            "dialCode": "+7",
            "twoLetterCode": "KZ"
        },
        {
            "displayText": "Kenya",
            "value": CountryCode.KEN,
            "dialCode": "+254",
            "twoLetterCode": "KE"
        },
        {
            "displayText": "Kyrgyzstan",
            "value": CountryCode.KGZ,
            "dialCode": "+996",
            "twoLetterCode": "KG"
        },
        {
            "displayText": "Cambodia",
            "value": CountryCode.KHM,
            "dialCode": "+855",
            "twoLetterCode": "KH"
        },
        {
            "displayText": "Kiribati",
            "value": CountryCode.KIR,
            "dialCode": "+686",
            "twoLetterCode": "KI"
        },
        {
            "displayText": "Saint Kitts And Nevis",
            "value": CountryCode.KNA,
            "dialCode": "+1869",
            "twoLetterCode": "KN"
        },
        {
            "displayText": "Korea (Republic)",
            "value": CountryCode.KOR,
            "dialCode": "+82",
            "twoLetterCode": "KR"
        },
        {
            "displayText": "Kuwait",
            "value": CountryCode.KWT,
            "dialCode": "+965",
            "twoLetterCode": "KW"
        },
        {
            "displayText": "Lao (People's Democratic Republic)",
            "value": CountryCode.LAO,
            "dialCode": "+856",
            "twoLetterCode": "LA"
        },
        {
            "displayText": "Lebanon",
            "value": CountryCode.LBN,
            "dialCode": "+961",
            "twoLetterCode": "LB"
        },
        {
            "displayText": "Liberia",
            "value": CountryCode.LBR,
            "dialCode": "+231",
            "twoLetterCode": "LR"
        },
        {
            "displayText": "Libya",
            "value": CountryCode.LBY,
            "dialCode": "+218",
            "twoLetterCode": "LY"
        },
        {
            "displayText": "Saint Lucia",
            "value": CountryCode.LCA,
            "dialCode": "+1758",
            "twoLetterCode": "LC"
        },
        {
            "displayText": "Liechtenstein",
            "value": CountryCode.LIE,
            "dialCode": "+423",
            "twoLetterCode": "LI"
        },
        {
            "displayText": "Sri Lanka",
            "value": CountryCode.LKA,
            "dialCode": "+94",
            "twoLetterCode": "LK"
        },
        {
            "displayText": "Lesotho",
            "value": CountryCode.LSO,
            "dialCode": "+266",
            "twoLetterCode": "LS"
        },
        {
            "displayText": "Lithuania",
            "value": CountryCode.LTU,
            "dialCode": "+370",
            "twoLetterCode": "LT"
        },
        {
            "displayText": "Luxembourg",
            "value": CountryCode.LUX,
            "dialCode": "+352",
            "twoLetterCode": "LU"
        },
        {
            "displayText": "Latvia",
            "value": CountryCode.LVA,
            "dialCode": "+371",
            "twoLetterCode": "LV"
        },
        {
            "displayText": "Macao",
            "value": CountryCode.MAC,
            "dialCode": "+853",
            "twoLetterCode": "MO"
        },
        {
            "displayText": "Saint Martin (French Part)",
            "value": CountryCode.MAF,
            "dialCode": "+590",
            "twoLetterCode": "MF"
        },
        {
            "displayText": "Morocco",
            "value": CountryCode.MAR,
            "dialCode": "+212",
            "twoLetterCode": "MA"
        },
        {
            "displayText": "Monaco",
            "value": CountryCode.MCO,
            "dialCode": "+377",
            "twoLetterCode": "MC"
        },
        {
            "displayText": "Moldova",
            "value": CountryCode.MDA,
            "dialCode": "+373",
            "twoLetterCode": "MD"
        },
        {
            "displayText": "Madagascar",
            "value": CountryCode.MDG,
            "dialCode": "+261",
            "twoLetterCode": "MG"
        },
        {
            "displayText": "Maldives",
            "value": CountryCode.MDV,
            "dialCode": "+960",
            "twoLetterCode": "MV"
        },
        {
            "displayText": "Mexico",
            "value": CountryCode.MEX,
            "dialCode": "+52",
            "twoLetterCode": "MX"
        },
        {
            "displayText": "Marshall Islands",
            "value": CountryCode.MHL,
            "dialCode": "+692",
            "twoLetterCode": "MH"
        },
        {
            "displayText": "Macedonia",
            "value": CountryCode.MKD,
            "dialCode": "+389",
            "twoLetterCode": "MK"
        },
        {
            "displayText": "Mali",
            "value": CountryCode.MLI,
            "dialCode": "+223",
            "twoLetterCode": "ML"
        },
        {
            "displayText": "Malta",
            "value": CountryCode.MLT,
            "dialCode": "+356",
            "twoLetterCode": "MT"
        },
        {
            "displayText": "Myanmar",
            "value": CountryCode.MMR,
            "dialCode": "+95",
            "twoLetterCode": "MM"
        },
        {
            "displayText": "Montenegro",
            "value": CountryCode.MNE,
            "dialCode": "+382",
            "twoLetterCode": "ME"
        },
        {
            "displayText": "Mongolia",
            "value": CountryCode.MNG,
            "dialCode": "+976",
            "twoLetterCode": "MN"
        },
        {
            "displayText": "Northern Mariana Islands",
            "value": CountryCode.MNP,
            "dialCode": "+1670",
            "twoLetterCode": "MP"
        },
        {
            "displayText": "Mozambique",
            "value": CountryCode.MOZ,
            "dialCode": "+258",
            "twoLetterCode": "MZ"
        },
        {
            "displayText": "Mauritania",
            "value": CountryCode.MRT,
            "dialCode": "+222",
            "twoLetterCode": "MR"
        },
        {
            "displayText": "Montserrat",
            "value": CountryCode.MSR,
            "dialCode": "+1664",
            "twoLetterCode": "MS"
        },
        {
            "displayText": "Martinique",
            "value": CountryCode.MTQ,
            "dialCode": "+596",
            "twoLetterCode": "MQ"
        },
        {
            "displayText": "Mauritius",
            "value": CountryCode.MUS,
            "dialCode": "+230",
            "twoLetterCode": "MU"
        },
        {
            "displayText": "Malawi",
            "value": CountryCode.MWI,
            "dialCode": "+265",
            "twoLetterCode": "MW"
        },
        {
            "displayText": "Malaysia",
            "value": CountryCode.MYS,
            "dialCode": "+60",
            "twoLetterCode": "MY"
        },
        {
            "displayText": "Mayotte",
            "value": CountryCode.MYT,
            "dialCode": "+262",
            "twoLetterCode": "YT"
        },
        {
            "displayText": "Namibia",
            "value": CountryCode.NAM,
            "dialCode": "+264",
            "twoLetterCode": "NA"
        },
        {
            "displayText": "New Caledonia",
            "value": CountryCode.NCL,
            "dialCode": "+687",
            "twoLetterCode": "NC"
        },
        {
            "displayText": "Niger",
            "value": CountryCode.NER,
            "dialCode": "+227",
            "twoLetterCode": "NE"
        },
        {
            "displayText": "Norfolk Island",
            "value": CountryCode.NFK,
            "dialCode": "+672",
            "twoLetterCode": "NF"
        },
        {
            "displayText": "Nigeria",
            "value": CountryCode.NGA,
            "dialCode": "+234",
            "twoLetterCode": "NG"
        },
        {
            "displayText": "Nicaragua",
            "value": CountryCode.NIC,
            "dialCode": "+505",
            "twoLetterCode": "NI"
        },
        {
            "displayText": "Niue",
            "value": CountryCode.NIU,
            "dialCode": "+683",
            "twoLetterCode": "NU"
        },
        {
            "displayText": "United Kingdom (Northern Ireland)",
            "value": CountryCode.NIR,
            "dialCode": "+44",
            "twoLetterCode": "GB"
        },
        {
            "displayText": "Netherlands",
            "value": CountryCode.NLD,
            "dialCode": "+31",
            "enableCbPayments": true,
            "restrictedEnv": US_PROFILE,
            "twoLetterCode": "NL"
        },
        {
            "displayText": "Norway",
            "value": CountryCode.NOR,
            "dialCode": "+47",
            "twoLetterCode": "NO"
        },
        {
            "displayText": "Nepal",
            "value": CountryCode.NPL,
            "dialCode": "+977",
            "twoLetterCode": "NP"
        },
        {
            "displayText": "Nauru",
            "value": CountryCode.NRU,
            "dialCode": "+674",
            "twoLetterCode": "NR"
        },
        {
            "displayText": "New Zealand",
            "value": CountryCode.NZL,
            "dialCode": "+64",
            "twoLetterCode": "NZ"
        },
        {
            "displayText": "Oman",
            "value": CountryCode.OMN,
            "dialCode": "+968",
            "twoLetterCode": "OM"
        },
        {
            "displayText": "Pakistan",
            "value": CountryCode.PAK,
            "dialCode": "+92",
            "twoLetterCode": "PK"
        },
        {
            "displayText": "Panama",
            "value": CountryCode.PAN,
            "dialCode": "+507",
            "twoLetterCode": "PA"
        },
        {
            "displayText": "Pitcairn",
            "value": CountryCode.PCN,
            "dialCode": "+64",
            "twoLetterCode": "PN"
        },
        {
            "displayText": "Peru",
            "value": CountryCode.PER,
            "dialCode": "+51",
            "twoLetterCode": "PE"
        },
        {
            "displayText": "Philippines",
            "value": CountryCode.PHL,
            "dialCode": "+63",
            "twoLetterCode": "PH"
        },
        {
            "displayText": "Palau",
            "value": CountryCode.PLW,
            "dialCode": "+680",
            "twoLetterCode": "PW"
        },
        {
            "displayText": "Papua New Guinea",
            "value": CountryCode.PNG,
            "dialCode": "+675",
            "twoLetterCode": "PG"
        },
        {
            "displayText": "Poland",
            "value": CountryCode.POL,
            "dialCode": "+48",
            "twoLetterCode": "PL"
        },
        {
            "displayText": "Puerto Rico",
            "value": CountryCode.PRI,
            "dialCode": "+1",
            "twoLetterCode": "PR"
        },
        {
            "displayText": "Korea (Democratic People's Republic)",
            "value": CountryCode.PRK,
            "dialCode": "+850",
            "twoLetterCode": "KP"
        },
        {
            "displayText": "Portugal",
            "value": CountryCode.PRT,
            "dialCode": "+351",
            "twoLetterCode": "PT"
        },
        {
            "displayText": "Paraguay",
            "value": CountryCode.PRY,
            "dialCode": "+595",
            "twoLetterCode": "PY"
        },
        {
            "displayText": "Palestinian Territory (Occupied)",
            "value": CountryCode.PSE,
            "dialCode": "+970",
            "twoLetterCode": "PS"
        },
        {
            "displayText": "French Polynesia",
            "value": CountryCode.PYF,
            "dialCode": "+689",
            "twoLetterCode": "PF"
        },
        {
            "displayText": "Qatar",
            "value": CountryCode.QAT,
            "dialCode": "+974",
            "twoLetterCode": "QA"
        },
        {
            "displayText": "Reunion",
            "value": CountryCode.REU,
            "dialCode": "+262",
            "twoLetterCode": "RE"
        },
        {
            "displayText": "Romania",
            "value": CountryCode.ROU,
            "dialCode": "+40",
            "twoLetterCode": "RO"
        },
        {
            "displayText": "Russian Federation",
            "value": CountryCode.RUS,
            "dialCode": "+7",
            "twoLetterCode": "RU"
        },
        {
            "displayText": "Rwanda",
            "value": CountryCode.RWA,
            "dialCode": "+250",
            "twoLetterCode": "RW"
        },
        {
            "displayText": "Saudi Arabia",
            "value": CountryCode.SAU,
            "dialCode": "+966",
            "twoLetterCode": "SA"
        },
        {
            "displayText": "Sudan",
            "value": CountryCode.SDN,
            "dialCode": "+249",
            "twoLetterCode": "SD"
        },
        {
            "displayText": "Senegal",
            "value": CountryCode.SEN,
            "dialCode": "+221",
            "twoLetterCode": "SN"
        },
        {
            "displayText": "Singapore",
            "value": CountryCode.SGP,
            "dialCode": "+65",
            "twoLetterCode": "SG"
        },
        {
            "displayText": "South Georgia And The South Sandwich Islands",
            "value": CountryCode.SGS,
            "dialCode": "+500",
            "twoLetterCode": "GS"
        },
        {
            "displayText": "Saint Helena",
            "value": CountryCode.SHN,
            "dialCode": "+290",
            "twoLetterCode": "SH"
        },
        {
            "displayText": "Svalbard And Jan Mayen",
            "value": CountryCode.SJM,
            "dialCode": "+47",
            "twoLetterCode": "SJ"
        },
        {
            "displayText": "Solomon Islands",
            "value": CountryCode.SLB,
            "dialCode": "+677",
            "twoLetterCode": "SB"
        },
        {
            "displayText": "Sierra Leone",
            "value": CountryCode.SLE,
            "dialCode": "+232",
            "twoLetterCode": "SL"
        },
        {
            "displayText": "El Salvador",
            "value": CountryCode.SLV,
            "dialCode": "+503",
            "twoLetterCode": "SV"
        },
        {
            "displayText": "San Marino",
            "value": CountryCode.SMR,
            "dialCode": "+378",
            "twoLetterCode": "SM"
        },
        {
            "displayText": "Somalia",
            "value": CountryCode.SOM,
            "dialCode": "+252",
            "twoLetterCode": "SO"
        },
        {
            "displayText": "Saint Pierre And Miquelon",
            "value": CountryCode.SPM,
            "dialCode": "+508",
            "twoLetterCode": "PM"
        },
        {
            "displayText": "Serbia",
            "value": CountryCode.SRB,
            "dialCode": "+381",
            "twoLetterCode": "RS"
        },
        {
            "displayText": "South Sudan",
            "value": CountryCode.SSD,
            "dialCode": "+211",
            "twoLetterCode": "SS"
        },
        {
            "displayText": "Sao Tome And Principe",
            "value": CountryCode.STP,
            "dialCode": "+239",
            "twoLetterCode": "ST"
        },
        {
            "displayText": "Suriname",
            "value": CountryCode.SUR,
            "dialCode": "+597",
            "twoLetterCode": "SR"
        },
        {
            "displayText": "Slovakia",
            "value": CountryCode.SVK,
            "dialCode": "+421",
            "twoLetterCode": "SK"
        },
        {
            "displayText": "Slovenia",
            "value": CountryCode.SVN,
            "dialCode": "+386",
            "twoLetterCode": "SI"
        },
        {
            "displayText": "Sweden",
            "value": CountryCode.SWE,
            "dialCode": "+46",
            "twoLetterCode": "SE"
        },
        {
            "displayText": "Swaziland",
            "value": CountryCode.SWZ,
            "dialCode": "+268",
            "twoLetterCode": "SZ"
        },
        {
            "displayText": "Sint Maarten (Dutch Part)",
            "value": CountryCode.SXM,
            "dialCode": "+1721",
            "twoLetterCode": "SX"
        },
        {
            "displayText": "Seychelles",
            "value": CountryCode.SYC,
            "dialCode": "+248",
            "twoLetterCode": "SC"
        },
        {
            "displayText": "Syrian Arab Republic",
            "value": CountryCode.SYR,
            "dialCode": "+963",
            "twoLetterCode": "SY"
        },
        {
            "displayText": "Turks And Caicos Islands",
            "value": CountryCode.TCA,
            "dialCode": "+1649",
            "twoLetterCode": "TC"
        },
        {
            "displayText": "Chad",
            "value": CountryCode.TCD,
            "dialCode": "+235",
            "twoLetterCode": "TD"
        },
        {
            "displayText": "Togo",
            "value": CountryCode.TGO,
            "dialCode": "+228",
            "twoLetterCode": "TG"
        },
        {
            "displayText": "Thailand",
            "value": CountryCode.THA,
            "dialCode": "+66",
            "twoLetterCode": "TH"
        },
        {
            "displayText": "Tajikistan",
            "value": CountryCode.TJK,
            "dialCode": "+992",
            "twoLetterCode": "TJ"
        },
        {
            "displayText": "Tokelau",
            "value": CountryCode.TKL,
            "dialCode": "+690",
            "twoLetterCode": "TK"
        },
        {
            "displayText": "Turkmenistan",
            "value": CountryCode.TKM,
            "dialCode": "+993",
            "twoLetterCode": "TM"
        },
        {
            "displayText": "Timor-leste",
            "value": CountryCode.TLS,
            "dialCode": "+670",
            "twoLetterCode": "TL"
        },
        {
            "displayText": "Tonga",
            "value": CountryCode.TON,
            "dialCode": "+676",
            "twoLetterCode": "TO"
        },
        {
            "displayText": "Trinidad And Tobago",
            "value": CountryCode.TTO,
            "dialCode": "+1868",
            "twoLetterCode": "TT"
        },
        {
            "displayText": "Tunisia",
            "value": CountryCode.TUN,
            "dialCode": "+216",
            "twoLetterCode": "TN"
        },
        {
            "displayText": "Turkey",
            "value": CountryCode.TUR,
            "dialCode": "+90",
            "twoLetterCode": "TR"
        },
        {
            "displayText": "Tuvalu",
            "value": CountryCode.TUV,
            "dialCode": "+688",
            "twoLetterCode": "TV"
        },
        {
            "displayText": "Taiwan",
            "value": CountryCode.TWN,
            "dialCode": "+886",
            "twoLetterCode": "TW"
        },
        {
            "displayText": "Tanzania",
            "value": CountryCode.TZA,
            "dialCode": "+255",
            "twoLetterCode": "TZ"
        },
        {
            "displayText": "Uganda",
            "value": CountryCode.UGA,
            "dialCode": "+256",
            "twoLetterCode": "UG"
        },
        {
            "displayText": "Ukraine",
            "value": CountryCode.UKR,
            "dialCode": "+380",
            "twoLetterCode": "UA"
        },
        {
            "displayText": "United States Minor Outlying Islands",
            "value": CountryCode.UMI,
            "dialCode": "+1",
            "twoLetterCode": "UM"
        },
        {
            "displayText": "Uruguay",
            "value": CountryCode.URY,
            "dialCode": "+598",
            "twoLetterCode": "UY"
        },
        {
            "displayText": "United States",
            "value": CountryCode.USA,
            "dialCode": "+1",
            "enableCbPayments": true,
            "restrictedEnv": EU_PROFILE,
            "twoLetterCode": "US"
        },
        {
            "displayText": "Uzbekistan",
            "value": CountryCode.UZB,
            "dialCode": "+998",
            "twoLetterCode": "UZ"
        },
        {
            "displayText": "Vatican City",
            "value": CountryCode.VAT,
            "dialCode": "+39",
            "twoLetterCode": "VA"
        },
        {
            "displayText": "Saint Vincent And The Grenadines",
            "value": CountryCode.VCT,
            "dialCode": "+1784",
            "twoLetterCode": "VC"
        },
        {
            "displayText": "Venezuela",
            "value": CountryCode.VEN,
            "dialCode": "+58",
            "twoLetterCode": "VE"
        },
        {
            "displayText": "British Virgin Islands",
            "value": CountryCode.VGB,
            "dialCode": "+1284",
            "twoLetterCode": "VG"
        },
        {
            "displayText": "U.S. Virgin Islands",
            "value": CountryCode.VIR,
            "dialCode": "+1340",
            "twoLetterCode": "VI"
        },
        {
            "displayText": "Viet Nam",
            "value": CountryCode.VNM,
            "dialCode": "+84",
            "twoLetterCode": "VN"
        },
        {
            "displayText": "Vanuatu",
            "value": CountryCode.VUT,
            "dialCode": "+678",
            "twoLetterCode": "VU"
        },
        {
            "displayText": "Wallis And Futuna",
            "value": CountryCode.WLF,
            "dialCode": "+681",
            "twoLetterCode": "WF"
        },
        {
            "displayText": "Samoa",
            "value": CountryCode.WSM,
            "dialCode": "+685",
            "twoLetterCode": "WS"
        },
        {
            "displayText": "Kosovo",
            "value": CountryCode.XKX,
            "dialCode": "+383",
            "twoLetterCode": "XK"
        },
        {
            "displayText": "Yemen",
            "value": CountryCode.YEM,
            "dialCode": "+967",
            "twoLetterCode": "YE"
        },
        {
            "displayText": "South Africa",
            "value": CountryCode.ZAF,
            "dialCode": "+27",
            "twoLetterCode": "ZA"
        },
        {
            "displayText": "Zambia",
            "value": CountryCode.ZMB,
            "dialCode": "+260",
            "twoLetterCode": "ZM"
        },
        {
            "displayText": "Zimbabwe",
            "value": CountryCode.ZWE,
            "dialCode": "+263",
            "twoLetterCode": "ZW"
        }
    ]
;

export const getDialCodeByCountryCode = (countryCode: CountryCode) => {
    return CountryCodeList.find(x => x.value === countryCode)?.dialCode;
}

export const CBPaymentsEnabledCountries = CountryCodeList.filter(x => x.enableCbPayments).sort((a,b) => a.displayText.localeCompare(b.displayText));

export const CountryCodeListSortedByName = CountryCodeList.sort((a,b) => a.displayText.localeCompare(b.displayText))
